import { mapActions } from 'vuex';
import { MODALS } from '@/components/app/app-modals/modals-constants';

export default {
  methods: {
    ...mapActions('popup', ['setCurrentSmallPopup']),
    ...mapActions('user', ['setWatchedUserDetails']),
    showUserDetails(item) {
      const profitablePredictions =
        (typeof item.totalProfitablePredictions !== 'undefined'
          ? item.totalProfitablePredictions
          : item.profitablePredictions) || 0;
      this.setCurrentSmallPopup(MODALS.SMALL_USER_PROFILE);
      const trader = {
        userName: item.userName,
        avatarImage: item.avatarImage,
        traderLevel: item.traderLevel || null,
        profitablePredictions,
      };
      this.setWatchedUserDetails(trader);
    },
  },
};
